<template>
	<div class="share" v-if="showPanel">
		<div class="share__panel">
            <template v-if="type === 2">
                <h6>
                    {{ $t('message.shareGuid2.title') }}
                </h6>
                <p class="_desc">
                    {{ $t('message.shareGuid2.desc') }}
                </p>
            </template>
            <template v-else>
                <div class="share__login">
                    <img
                        src="@/assets/imgs/invite-logo.png"
                        alt="close"
                    />
                </div>
                <div class="share__title">
                    <img class="star star-left" src="https://fr-static.shopshopslive.com/20220826/invite-star.8808c44877bdf5db.png" alt="">
                    <img class="star star-right" src="https://fr-static.shopshopslive.com/20220826/invite-star.8808c44877bdf5db.png" alt="">
                    Welcome to ShopShops!
                </div>
                <div class="share__desc__coupon">
                    Add some luxury to your life. Save $75 on a purchase above $250
                </div>
                <div class="share__desc">
                    DOWNLOAD THE APP TO USE YOUR SHOPSHOPS CASH
                </div>
            </template>

			<div class="share__button global_pointer" @click="downloadApp" v-if="isIOS">
				<span>{{ $t("message.share.downloadButtonText") }}</span>
			</div>

			<img
				class="share__close global_pointer"
				src="@/assets/imgs/login/icon-back.png"
				alt="close"
				@click="closePopup"
			/>
		</div>
	</div>
</template>

<script>
import { plateForm, getUrlQuery } from "@/utils";
const isAndroid = plateForm().isAndroid;
const isIOS = plateForm().isIOS;
import OpenApp from "@/common/openApp";
const jumpType = getUrlQuery("jumpType"),
	jumpId = getUrlQuery("jumpId");
const openApp = new OpenApp();
import clipboard from "@/utils/clipboard.js";
import api from "@/api/api_list";
export default {
	name: "shareGuide",
	data() {
		return {
			showguide: !isAndroid,
			showPanel: false,
			isIOS,
			closeCBK: null
		};
	},
	props: ["name", "inviteCode", "price", "headImgUrl", "type"],
	
	watch:{
		showPanel(nVal){
			if( !nVal && this.closeCBK ){
				this.closeCBK();
			}
		}
	},

	mounted() {
		this.getListConfig();
	},
	methods: {
		// 获取优惠配置列表
		getListConfig() {
			api.get_list_config({
				dictType: "NewbeePackage",
			}).then((res) => {
				console.log(111, res);
				res.result.forEach((item) => {
					if (item.dictCode === "newbee-package-en") {
						this.price =
							"$" + JSON.parse(item.dictName).discountMoney;
					}
				});
			});
		},

		closePopup() {
			this.showPanel = false;
		},

		async downloadApp() {

			if( location.pathname.search('/activity/share_earn')!==-1 ){
				try{
					this.sa.track({
						eventId: 'clickReferralUserDownload',
						eventParam: {
							platformType: 'H5',
						}
					});
				}catch(e){
					console.log(e)
				}
			}

			this.showPanel = false;

			if (isIOS) {
				openApp.init({
					auto: false,
					isLink: true,
					action: {
						jumpType,
						jumpId,
					},
				});
				openApp._goUniversal();
			} else {
				this.$isLogin();
			}
		},

		// submit() {
		// 	clipboard(
		// 		this.inviteCode,
		// 		function name(params) {
		// 			this.$toast(this.$t("message.room.copySuccess"));
		// 		}.bind(this)
		// 	);

		// 	this.downloadApp();
		// },
		
		open( closeCBK ) {
			this.showPanel = true;
			if(closeCBK){
				this.closeCBK = closeCBK;
			}
		},
	},
};
</script>


<style lang="less" scoped>
.share {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 100;
    font-family: Helvetica;
    &__login{
        text-align: center;
        padding: 28px 0 22px;
        img{
            width: 28px;
            height: 51px;
        }
    }
    &__title{
        position: relative;
        font-size: 25px;
        padding: 0 50px;
        white-space: nowrap;
        img{
            width: 26px;
            height: 33px;
            position: absolute;
            top: -16px;
        }
        .star-left{
            left: 24px;
        }
        .star-right{
            right: 24px;
            transform: rotate(180deg);
        }
    }
    &__desc__coupon{
        padding: 19px 60px 17px;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
    }
    &__desc{
        font-size: 13px;
        text-align: center;
        padding: 0 22px;
    }
	&__fdesc {
		display: flex;
		justify-content: center;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		line-height: 30px;
		color: #666666;

		& span {
			color: #333333;
			margin-left: 1px;
		}
		& img {
			width: 30px;
			height: 30px;
			margin-right: 8px;
			border-radius: 15px;
		}
	}
	&__panel {
		position: absolute;
		width: 100%;
		background: #FDF4EE;
		left: 0;
		bottom: 0;
		right:0;
		overflow: hidden;
		box-sizing: border-box;
		min-height: 178px;
		max-height: 375px;
		max-width: 10rem;
		margin-left: auto;
		margin-right: auto;
		h6 {
			text-align: center;
			font-family: TradeGothicLT-Bold, TradeGothicLT;
			font-size: 24px;
			color: #000;
			padding-top: 49px;
			padding-bottom: 20px;
			// width: 56.2%;
    		margin: 0 auto;
		}
		._desc {
			text-align: center;
			font-family: TradeGothicLT;
			font-size: 18px;
			color: #000;
			padding-bottom: 42px;
			width: 298px;
			margin-left: auto;
			margin-right: auto;
		}
	}
	&__button {
		margin: 40px auto 36px auto;
		width: 311px;
		height: 46px;
		border-radius: 23px;
		background: #222222;
		display: flex;
		justify-content: center;
		align-items: center;
		& span {
			height: 22px;
			font-size: 15px;
			font-family: Helvetica;
			color: #ffffff;
			line-height: 22px;
		}
	}
	&__close {
		width: 26px;
		height: 26px;
		position: absolute;
		left: 12px;
		top: 12px;
	}
}
</style>
